// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ShoppingBag20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ShoppingBag20: FC<ShoppingBag20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M4.5 18c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 3 16.5v-10c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44H6c0-1.107.39-2.05 1.171-2.83C7.952 1.39 8.897 1 10.005 1s2.05.39 2.828 1.17C13.611 2.95 14 3.893 14 5h1.5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .413-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11Zm0-1.5h11v-10h-11v10Zm5.505-4.5c1.108 0 2.05-.39 2.828-1.17C13.611 10.05 14 9.107 14 8h-1.5c0 .694-.243 1.285-.73 1.77a2.411 2.411 0 0 1-1.77.73 2.411 2.411 0 0 1-1.77-.73A2.41 2.41 0 0 1 7.5 8H6c0 1.111.39 2.056 1.171 2.833.781.778 1.726 1.167 2.834 1.167ZM7.5 5h5c0-.694-.243-1.285-.73-1.77A2.41 2.41 0 0 0 10 2.5a2.41 2.41 0 0 0-1.77.73A2.41 2.41 0 0 0 7.5 5Z" />
        </svg>
    );
};

export default ShoppingBag20;
